import { setInnerHtmlSanitized } from "@kaggle/core";
import { Icon } from "@kaggle/material";
import * as React from "react";
import { ScriptTipResult } from "../../../scripttips/ScriptTipResult";

const iconStyle: React.CSSProperties = {
  margin: "0 16px",
  padding: "10px",
  verticalAlign: "middle",
};

interface Props {
  scriptTip?: ScriptTipResult;
}

export const ScriptTips: React.FC<Props> = (props: Props) => {
  if (!props.scriptTip) {
    return null;
  }
  const { scriptTip } = props;
  if (!scriptTip.textToShow && !scriptTip.htmlToShow) {
    return null;
  }

  return (
    <div
      className={"script-tips-main-div"}
      style={{
        alignItems: "center",
        borderBottomStyle: "solid",
        borderBottomWidth: "1px",
        display: "flex",
        fontFamily: "Inter",
        marginLeft: "56px",
      }}
    >
      <Icon icon="info" size="inline" style={iconStyle} />
      {scriptTip.htmlToShow ? (
        setInnerHtmlSanitized(<span />, scriptTip.htmlToShow, {
          allowUnsanitized: true,
          allowExternalImages: true,
          allowAnchorTarget: true,
        })
      ) : (
        <span>{scriptTip.textToShow}</span>
      )}
    </div>
  );
};
